export interface Municipality {
	value: string
	label: string
}

export interface Province {
	value: string
	label: string
	municipalities: Municipality[]
}

export const provinces: Province[] = [
	{
		value: "distrito_nacional",
		label: "Distrito Nacional",
		municipalities: [
			{ value: "santo_domingo", label: "Santo Domingo de Guzmán" },
		],
	},
	{
		value: "azua",
		label: "Azua",
		municipalities: [
			{ value: "azua", label: "Azua" },
			{ value: "las_yaras", label: "Las Yaras" },
			{ value: "sabana_yegua", label: "Sabana Yegua" },
			{ value: "pueblo_viejo", label: "Pueblo Viejo" },
			{ value: "guayabal", label: "Guayabal" },
			{ value: "padre_casas", label: "Padre Las Casas" },
		],
	},
	{
		value: "bahoruco",
		label: "Bahoruco",
		municipalities: [
			{ value: "neiba", label: "Neiba" },
			{ value: "los_baenos", label: "Los Baenos" },
			{ value: "villa_jaragua", label: "Villa Jaragua" },
			{ value: "tamayo", label: "Tamayo" },
			{ value: "uvilla", label: "Uvilla" },
		],
	},
	{
		value: "barahona",
		label: "Barahona",
		municipalities: [
			{ value: "barahona", label: "Barahona" },
			{ value: "cabral", label: "Cabral" },
			{ value: "el_penon", label: "El Peñón" },
			{ value: "la_descubierta", label: "La Descubierta" },
			{ value: "paraiso", label: "Paraíso" },
			{ value: "vicente_noble", label: "Vicente Noble" },
			{ value: "jaquimeyes", label: "Jaquimeyes" },
			{ value: "polo", label: "Polo" },
		],
	},
	{
		value: "dajabon",
		label: "Dajabón",
		municipalities: [
			{ value: "dajabon", label: "Dajabón" },
			{ value: "loma_de_cabrera", label: "Loma de Cabrera" },
			{ value: "partido", label: "Partido" },
			{ value: "restauracion", label: "Restauración" },
		],
	},
	{
		value: "duarte",
		label: "Duarte",
		municipalities: [
			{ value: "san_francisco_macoris", label: "San Francisco de Macorís" },
			{ value: "arenoso", label: "Arenoso" },
			{ value: "castillo", label: "Castillo" },
			{ value: "las_guaranas", label: "Las Guáranas" },
			{ value: "pimentel", label: "Pimentel" },
			{ value: "villa_riva", label: "Villa Riva" },
		],
	},
	{
		value: "el_seibo",
		label: "El Seibo",
		municipalities: [
			{ value: "santa_cruz_seibo", label: "Santa Cruz de El Seibo" },
			{ value: "miches", label: "Miches" },
			{ value: "el_valle_seibo", label: "El Valle" },
		],
	},
	{
		value: "elias_pina",
		label: "Elías Piña",
		municipalities: [
			{ value: "comendador", label: "Comendador" },
			{ value: "banica", label: "Bánica" },
			{ value: "juan_santiago", label: "Juan Santiago" },
			{ value: "el_llano", label: "El Llano" },
		],
	},
	{
		value: "espaillat",
		label: "Espaillat",
		municipalities: [
			{ value: "moca", label: "Moca" },
			{ value: "cayetano_gomosem", label: "Cayetano Germosén" },
			{ value: "gaspar_hernandez", label: "Gaspar Hernández" },
			{ value: "jamao_al_norte", label: "Jamao al Norte" },
		],
	},
	{
		value: "hato_mayor",
		label: "Hato Mayor",
		municipalities: [
			{ value: "hato_mayor_rey", label: "Hato Mayor del Rey" },
			{ value: "el_valle_hato", label: "El Valle" },
			{ value: "sabana_mar", label: "Sabana de la Mar" },
		],
	},
	{
		value: "hermanas_mirabal",
		label: "Hermanas Mirabal",
		municipalities: [
			{ value: "salcedo", label: "Salcedo" },
			{ value: "tenares", label: "Tenares" },
			{ value: "villa_tapia", label: "Villa Tapia" },
		],
	},
	{
		value: "independencia",
		label: "Independencia",
		municipalities: [
			{ value: "jimani", label: "Jimaní" },
			{ value: "cristobal", label: "Cristóbal" },
			{ value: "mella", label: "Mella" },
			{ value: "postrer_rio", label: "Postrer Río" },
			{ value: "duverge", label: "Duvergé" },
		],
	},
	{
		value: "la_altagracia",
		label: "La Altagracia",
		municipalities: [
			{ value: "higuey", label: "Higüey" },
			{ value: "san_antonio_guerra", label: "San Antonio de Guerra" },
			{ value: "san_rafael_yuma", label: "San Rafael del Yuma" },
			{ value: "boca_cuy", label: "Boca de Yuma" },
			{ value: "punta_cana", label: "Punta Cana" },
			{ value: "bavaro", label: "Bávaro" },
		],
	},
	{
		value: "la_romana",
		label: "La Romana",
		municipalities: [
			{ value: "la_romana", label: "La Romana" },
			{ value: "guaymate", label: "Guaymate" },
			{ value: "villa_hermosa", label: "Villa Hermosa" },
			{ value: "cumayasa", label: "Cumayasa" },
		],
	},
	{
		value: "la_vega",
		label: "La Vega",
		municipalities: [
			{ value: "la_vega", label: "La Vega" },
			{ value: "constanza", label: "Constanza" },
			{ value: "jarabacoa", label: "Jarabacoa" },
			{ value: "manabao", label: "Manabao" },
			{ value: "rio_verde_arriba", label: "Río Verde Arriba" },
			{ value: "tireo_vega", label: "Tireo" },
		],
	},
	{
		value: "maria_trinidad_sanchez",
		label: "María Trinidad Sánchez",
		municipalities: [
			{ value: "nagua", label: "Nagua" },
			{ value: "cabrera", label: "Cabrera" },
			{ value: "el_factor", label: "El Factor" },
			{ value: "rio_san_juan", label: "Río San Juan" },
		],
	},
	{
		value: "monsenor_nouel",
		label: "Monseñor Nouel",
		municipalities: [
			{ value: "bonao", label: "Bonao" },
			{ value: "maimon", label: "Maimón" },
			{ value: "piedra_blanca", label: "Piedra Blanca" },
		],
	},
	{
		value: "monte_plata",
		label: "Monte Plata",
		municipalities: [
			{ value: "monte_plata", label: "Monte Plata" },
			{ value: "bayaguana", label: "Bayaguana" },
			{ value: "sabana_grande_boya", label: "Sabana Grande de Boyá" },
			{ value: "yayas", label: "Yayas" },
		],
	},
	{
		value: "pedernales",
		label: "Pedernales",
		municipalities: [
			{ value: "pedernales", label: "Pedernales" },
			{ value: "oviedo", label: "Oviedo" },
			{ value: "boca_de_cacheo", label: "Boca de Cachéo" },
		],
	},
	{
		value: "peravia",
		label: "Peravia",
		municipalities: [
			{ value: "bani", label: "Baní" },
			{ value: "nizao", label: "Nizao" },
			{ value: "sabana_buey", label: "Sabana Buey" },
			{ value: "pizarrete", label: "Pizarrete" },
		],
	},
	{
		value: "puerto_plata",
		label: "Puerto Plata",
		municipalities: [
			{ value: "puerto_plata", label: "Puerto Plata" },
			{ value: "altamira", label: "Altamira" },
			{ value: "esperanza_pp", label: "Esperanza" },
			{ value: "imbert", label: "Imbert" },
			{ value: "los_hidalgos", label: "Los Hidalgos" },
			{ value: "sosua", label: "Sosúa" },
			{ value: "cabarete", label: "Cabarete" },
		],
	},
	{
		value: "samana",
		label: "Samaná",
		municipalities: [
			{ value: "samana", label: "Samaná" },
			{ value: "las_terrenas", label: "Las Terrenas" },
			{ value: "sanchez_samana", label: "Sánchez" },
			{ value: "el_limon", label: "El Limón" },
		],
	},
	{
		value: "san_cristobal",
		label: "San Cristóbal",
		municipalities: [
			{ value: "san_cristobal", label: "San Cristóbal" },
			{ value: "villa_altagracia", label: "Villa Altagracia" },
			{ value: "yagate", label: "Yaguate" },
			{ value: "sabana_grande_palenque", label: "Sabana Grande de Palenque" },
			{ value: "los_cacaos", label: "Los Cacaos" },
			{ value: "haina", label: "Haina" },
		],
	},
	{
		value: "san_juan",
		label: "San Juan",
		municipalities: [
			{ value: "san_juan_maguana", label: "San Juan de la Maguana" },
			{ value: "san_jose_matas", label: "San José de las Matas" },
			{ value: "el_cercado", label: "El Cercado" },
			{ value: "juan_herrera", label: "Juan de Herrera" },
			{ value: "bohechio", label: "Bohechío" },
			{ value: "las_matas_farfan", label: "Las Matas de Farfán" },
		],
	},
	{
		value: "san_pedro_macoris",
		label: "San Pedro de Macorís",
		municipalities: [
			{ value: "san_pedro_macoris", label: "San Pedro de Macorís" },
			{ value: "consuelo", label: "Consuelo" },
			{ value: "quisqueya", label: "Quisqueya" },
			{ value: "guayabo_macoris", label: "Guayabo" },
		],
	},
	{
		value: "santiago",
		label: "Santiago",
		municipalities: [
			{ value: "santiago_ccc", label: "Santiago de los Caballeros" },
			{ value: "bisono", label: "Bisonó" },
			{ value: "janico", label: "Jánico" },
			{ value: "licey_medio", label: "Licey al Medio" },
			{ value: "san_jose_matas_stgo", label: "San José de las Matas" },
			{ value: "tamboril", label: "Tamboril" },
			{ value: "villa_gonzalez", label: "Villa González" },
			{ value: "punal", label: "Puñal" },
			{ value: "sabana_indep", label: "Sabana Inde" },
		],
	},
	{
		value: "santiago_rodriguez",
		label: "Santiago Rodríguez",
		municipalities: [
			{ value: "san_ignacio_sabaneta", label: "San Ignacio de Sabaneta" },
			{ value: "villa_los_baenos", label: "Villa Los Baenos de San Juan" },
			{ value: "moncion", label: "Monción" },
		],
	},
	{
		value: "sanchez_ramirez",
		label: "Sánchez Ramírez",
		municipalities: [
			{ value: "cotui", label: "Cotuí" },
			{ value: "cevicos", label: "Cevicos" },
			{ value: "la_mata", label: "La Mata" },
			{ value: "fantino", label: "Fantino" },
		],
	},
	{
		value: "valverde",
		label: "Valverde",
		municipalities: [
			{ value: "mao", label: "Mao" },
			{ value: "esperanza_v", label: "Esperanza" },
			{ value: "laguna_salada", label: "Laguna Salada" },
			{ value: "maizal", label: "Maizal" },
			{ value: "palo_verde", label: "Palo Verde" },
		],
	},
	{
		value: "san_jose_ocoa",
		label: "San José de Ocoa",
		municipalities: [
			{ value: "san_jose_ocoa", label: "San José de Ocoa" },
			{ value: "rancho_arriba", label: "Rancho Arriba" },
			{ value: "naron", label: "Naranjo" },
		],
	},
	{
		value: "santo_domingo",
		label: "Santo Domingo",
		municipalities: [
			{ value: "santo_domingo_este", label: "Santo Domingo Este" },
			{ value: "santo_domingo_oeste", label: "Santo Domingo Oeste" },
			{ value: "santo_domingo_norte", label: "Santo Domingo Norte" },
			{ value: "los_alcarrizos", label: "Los Alcarrizos" },
			{ value: "pantoja", label: "Pantoja" },
			{ value: "la_gomera", label: "La Gömana" },
			{ value: "san_antonio_guerra_sd", label: "San Antonio de Guerra" },
		],
	},
]
